'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["id", "name", "label", "objectTypeId", "isFormLabelPropertyEnabled", "handleDrag", "startDrag", "endDrag"];
import { useDrag } from 'react-dnd';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { DragTypes } from 'FormsUI/constants/DragAndDrop';
import Property from 'FormsUI/components/editor/leftPanel/properties/Property';
import { getFormFieldLabel } from 'FormsUI/utils/FormFieldsUtils';
import { startDrag, endDrag } from 'FormsUI/actions/DragState.ts';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyDragContainer = props => {
  const {
      id,
      name,
      label,
      objectTypeId,
      isFormLabelPropertyEnabled,
      handleDrag,
      startDrag: startDragAction,
      endDrag: endDragAction
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  const [{
    isDragging
  }, dragRef, dragPreviewRef] = useDrag(() => ({
    type: DragTypes.NEW_FORM_FIELD,
    item: () => {
      setTimeout(() => {
        handleDrag(name);
        startDragAction({
          type: 'property',
          id,
          name
        });
      });
      return {
        propertyId: id,
        propertyName: name,
        objectTypeId,
        propertyLabel: getFormFieldLabel(label),
        isFormLabelPropertyEnabled
      };
    },
    end: () => {
      setTimeout(() => {
        handleDrag();
        endDragAction();
      });
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  }), [id, name, label, objectTypeId, isFormLabelPropertyEnabled, handleDrag]);

  // Hide default drag preview
  useEffect(() => {
    dragPreviewRef(getEmptyImage());
  }, [dragPreviewRef]);
  return /*#__PURE__*/_jsx(Property, Object.assign({}, restProps, {
    id: id,
    name: name,
    label: label,
    objectTypeId: objectTypeId,
    isFormLabelPropertyEnabled: isFormLabelPropertyEnabled,
    connectDragSource: dragRef,
    connectDragPreview: dragPreviewRef,
    isBeingDragged: isDragging
  }));
};
const mapDispatchToProps = {
  startDrag,
  endDrag
};
export default connect(null, mapDispatchToProps)(PropertyDragContainer);